import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ShameClinicSection } from './components/ShameClinicSection';
import { CharactersGrid } from './components/CharactersGrid';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { DirectOfferSection } from './components/DirectOfferSection';
import { AuthorSection } from './components/AuthorSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-crema font-sans text-body selection:bg-gold/30" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ShameClinicSection data-id="element-4" />
        <CharactersGrid data-id="element-5" />
        <WhatYouGetSection data-id="element-6" />
        <DirectOfferSection data-id="element-7" />
        <AuthorSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}